
import { createContext, useContext, ReactNode } from 'react';
import { useCartState } from './cart/useCartState';
import { useCartActions } from './cart/useCartActions';
import type { CartItem } from './cart/useCartState';

// Re-export CartItem for external use
export type { CartItem };

type CartContextType = {
  cartItems: CartItem[];
  addToCart: (productId: string, quantity: number) => void;
  removeFromCart: (productId: string) => void;
  updateCartItemQuantity: (productId: string, quantity: number) => void;
  clearCart: () => void;
  debugCartAuth: () => Promise<any>;
};

const CartContext = createContext<CartContextType | undefined>(undefined);

export const CartProvider = ({ children }: { children: ReactNode }) => {
  const { cartItems, setCartItems, products } = useCartState();
  const { addToCart, removeFromCart, updateCartItemQuantity, clearCart, debugCartAuth } = useCartActions({
    products,
    setCartItems,
    cartItems
  });

  return (
    <CartContext.Provider
      value={{
        cartItems,
        addToCart,
        removeFromCart,
        updateCartItemQuantity,
        clearCart,
        debugCartAuth
      }}
    >
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => {
  const context = useContext(CartContext);
  if (context === undefined) {
    throw new Error('useCart must be used within a CartProvider');
  }
  return context;
};
